module.exports = __webpack_public_path__ + "img/last-mob.a172df2.webp";